export function getRegSystemIconMappingList(){
    return {
        fourType: {
            0: 'el-icon-close',
            1: 'el-icon-circle-check',
            2: 'el-icon-circle-close',
            888: 'el-icon-circle-check'
        },
        threeType: {
            0: 'tag-none',
            1: 'tag-warning',
            888: 'tag-success'
        }
    }
}
export function getRegDeviceIconMappingList(){
    return {
        etag: {
            0: 'tag-none',
            1: 'tag-warning',
            888: 'tag-success'
        },
        lpr: {
            0: 'tag-none',
            1: 'tag-warning',
            888: 'tag-success'
        },
        led: {
            0: 'tag-none',
            1: 'tag-warning',
            888: 'tag-success'
        }
    }
}
export function getRegSystemStatusMappingList(){
    return [
        {key: "live", value: 0},
        {key: "off", value: 1},
        {key: "hide", value: 99},
        {key: "del", value: 9999}
    ]
}